module.exports = __webpack_public_path__ + "img/icon-twitter.60860fbf.svg";